
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cities/[slug]",
      function () {
        return require("private-next-pages/cities/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cities/[slug]"])
      });
    }
  